module.exports = __webpack_public_path__ + "img/Scrum_icon.991e6200.svg";